import { pickUserEvent, UsageEventName, pickSystemEvent, } from '../Models/UsageTelemetry';
// Generate a new Feature properties
export function getFeature(capability, subCapability = undefined, subCapabilityLevel2 = undefined, location = undefined) {
    return {
        feature: Array.isArray(capability) ? capability.join('.') : capability,
        subFeature: Array.isArray(subCapability) ? subCapability.join('.') : subCapability || '',
        subFeatureLevel2: Array.isArray(subCapabilityLevel2)
            ? subCapabilityLevel2.join('.')
            : subCapabilityLevel2 || '',
        featureLocation: location || '',
    };
}
// Use to attach additional subFeatureLevel2 to existing Feature properties
export function mergeFeature(existing, subCapabilityLevel2 = undefined, location = undefined) {
    return Object.assign(Object.assign({}, existing), { subFeatureLevel2: `${existing.subFeatureLevel2 ? `${existing.subFeatureLevel2}.` : ''}${Array.isArray(subCapabilityLevel2) ? subCapabilityLevel2.join('.') : subCapabilityLevel2}`, featureLocation: location || existing.featureLocation });
}
// To be used with <Button />s and <Link />s which expect usageEvent property
export function getClickFeature(feature, subCapabilityLevel2 = undefined, location = undefined) {
    return {
        usageEvent: mergeFeature(feature, subCapabilityLevel2, location),
    };
}
// To be used with usePageTracking Hook
export function getPageLoadFeature(feature, subCapabilityLevel2 = undefined, location = undefined) {
    return pickUserEvent(Object.assign({ eventName: UsageEventName.PageLoad }, mergeFeature(feature, subCapabilityLevel2, location)));
}
export function getButtonClickFeature(feature, subCapabilityLevel2 = undefined, location = undefined) {
    return pickUserEvent(Object.assign({ eventName: UsageEventName.ButtonClicked }, mergeFeature(feature, subCapabilityLevel2, location)));
}
export function getLinkClickFeature(feature, subCapabilityLevel2 = undefined, location = undefined) {
    return pickUserEvent(Object.assign({ eventName: UsageEventName.LinkClicked }, mergeFeature(feature, subCapabilityLevel2, location)));
}
export function getAPICallFeature(feature, subCapabilityLevel2 = undefined, location = undefined) {
    return pickSystemEvent(Object.assign({ eventName: UsageEventName.BackEndAPICall }, mergeFeature(feature, subCapabilityLevel2, location)));
}
//# sourceMappingURL=UsageTelemetryHelper.js.map